var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('l-video',{staticClass:"video",attrs:{"src":"https://static.ycsd.work//site/b5.mp4"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }